import React from 'react';
import { NmButton } from './NmButton';

interface NmEmptyStateProps {
  children: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

/** Inset empty placeholder — VO2 DS. */
export function NmEmptyState({ children, actionLabel, onAction, className = '' }: NmEmptyStateProps) {
  return (
    <div className={`nm-empty-state ${className}`.trim()}>
      {children}
      {onAction && actionLabel && (
        <NmButton variant="primary" size="sm" onClick={onAction} style={{ marginTop: 12 }}>
          {actionLabel}
        </NmButton>
      )}
    </div>
  );
}
